import 'css-chunksrc/client/scenes/workloads/wbs/list/styles.scss';export default {
  "list": "_list_1cvjq_1",
  "contextualMenu": "_contextualMenu_1cvjq_5",
  "hovered": "_hovered_1cvjq_9",
  "name": "_name_1cvjq_9",
  "main": "_main_1cvjq_16",
  "displayedContextualMenu": "_displayedContextualMenu_1cvjq_47",
  "iconBox": "_iconBox_1cvjq_51",
  "elementsNbr": "_elementsNbr_1cvjq_57"
};